import {
  setAuctionsGridFilter,
  clearAuctionsGridFilter,
} from 'data/auctions/Auctions.actions';
import ReduxHelper from 'lib/ReduxHelper';

export const getMapStateToProps = state => {
  return ReduxHelper.mapStateWithLookups(
    {
      filters: state.auctions.filters,
      user: state.app.user,
    },
    state,
    'auctionStatuses',
    'bidFileTypes',
    'bidStatuses',
    'countries',
    'fuelTypes',
    'insurances',
    'partTypes',
    'partyTypes',
    'regions',
    'taxOffices',
    'imitationPartCategories',
    'usedConditionTypes',
    'applications',
    'memberships'
  );
};

export const getMapDispatchToProps = dispatch => {
  return {
    setFilter: (name, value) => dispatch(setAuctionsGridFilter(name, value)),
    clearFilters: () => dispatch(clearAuctionsGridFilter()),
  };
};
